import React from 'react';
import MediaQuery from 'react-responsive';

import PropTypes from 'prop-types';
import PreCheckoutBanner from './components/PreCheckoutBanner';
import ChecklistSection from './components/ChecklistSection';
import FeaturesSection from './components/FeaturesSection';

import Footer from './components/Footer';
import CompactFooter from './components/CompactFooter';

import styles from './index.scss';

const COMPACT_SCREEN_SIZE = 480;

const PackageSelect = ({
  headline,
  desktop_image: desktopImage,
  mobile_image: mobileImage,
  trialInfo,
  options,
  features_section: featuresSection,
  checklist_section: checklistSection
}) => {
  const option = options.find((o) => o.allAccess === true);
  return (
    <div className={styles.preCheckout}>
      <PreCheckoutBanner
        option={option}
        trialInfo={trialInfo}
        text={headline}
        desktopImage={desktopImage}
        mobileImage={mobileImage}
      />
      <div className={`${styles.container} container`}>
        <FeaturesSection featuresSection={featuresSection} />
      </div>
      <div
        className={`${styles.checklistWrapper} ${styles.desktop}`}
        style={{
          'background-image': `url(${checklistSection.desktop_background})`
        }}
      >
        <div className={`${styles.container} container`}>
          <ChecklistSection checklistSection={checklistSection} />
        </div>
      </div>
      <div
        className={`${styles.checklistWrapper} ${styles.mobile}`}
        style={{
          'background-image': `url(${checklistSection.mobile_background})`
        }}
      >
        <div className={`${styles.container} container`}>
          <ChecklistSection checklistSection={checklistSection} />
        </div>
      </div>

      {/* Bigger screens - tablets & desktop */}
      <MediaQuery minWidth={COMPACT_SCREEN_SIZE}>
        <Footer option={option} trialInfo={trialInfo} />
      </MediaQuery>
      {/* Smaller screens - phones */}
      <MediaQuery maxWidth={COMPACT_SCREEN_SIZE}>
        <CompactFooter option={option} trialInfo={trialInfo} />
      </MediaQuery>
    </div>
  );
};

PackageSelect.propTypes = {
  trialInfo: PropTypes.shape({
    trialLength: PropTypes.number,
    code: PropTypes.string
  }),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      allAccess: PropTypes.bool.isRequired,
      currency: PropTypes.string.isRequired,
      discountPercent: PropTypes.number.isRequired,
      packageIds: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
      priceWithDiscount: PropTypes.number.isRequired,
      priceWithoutDiscount: PropTypes.number.isRequired
    })
  ).isRequired,
  features_section: PropTypes.shape({}).isRequired,
  checklist_section: PropTypes.shape({}).isRequired,
  desktop_image: PropTypes.string.isRequired,
  mobile_image: PropTypes.string.isRequired,
  headline: PropTypes.string.isRequired
};

PackageSelect.defaultProps = {
  trialInfo: null
};

export default PackageSelect;
